import { jsxs as r, jsx as t } from "react/jsx-runtime";
function i(C) {
  return /* @__PURE__ */ r(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21",
      height: "21",
      viewBox: "0 0 21 21",
      fill: "none",
      ...C,
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            d: "M16.625 4.375H15.75V2.625C15.75 2.39294 15.6578 2.17038 15.4937 2.00628C15.3296 1.84219 15.1071 1.75 14.875 1.75C14.6429 1.75 14.4204 1.84219 14.2563 2.00628C14.0922 2.17038 14 2.39294 14 2.625V4.375H7V2.625C7 2.39294 6.90781 2.17038 6.74372 2.00628C6.57962 1.84219 6.35707 1.75 6.125 1.75C5.89294 1.75 5.67038 1.84219 5.50628 2.00628C5.34219 2.17038 5.25 2.39294 5.25 2.625V4.375H4.375C3.67881 4.375 3.01113 4.65156 2.51884 5.14385C2.02656 5.63613 1.75 6.30381 1.75 7V7.875H19.25V7C19.25 6.30381 18.9734 5.63613 18.4812 5.14385C17.9889 4.65156 17.3212 4.375 16.625 4.375Z",
            fill: "rgb(var(--text-tertiary))"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M1.75 16.625C1.75 17.3212 2.02656 17.9889 2.51884 18.4812C3.01113 18.9734 3.67881 19.25 4.375 19.25H16.625C17.3212 19.25 17.9889 18.9734 18.4812 18.4812C18.9734 17.9889 19.25 17.3212 19.25 16.625V9.625H1.75V16.625Z",
            fill: "rgb(var(--text-tertiary))"
          }
        )
      ]
    }
  );
}
export {
  i as CalendarIconFilled
};
